import { UserModel } from "src/app/modules/admin/user-management/user-model";

export class KeywordHistoryModel {
    modifiedValue: string;
    user: UserModel;
    dateModified: Date;
}